import { render, staticRenderFns } from "./SQLMonitor.vue?vue&type=template&id=6549187c&"
import script from "./SQLMonitor.vue?vue&type=script&lang=js&"
export * from "./SQLMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports